<template>
    <div>
        <div class="row justify-content-end">
            <a class="btn btn-primary next-step" @click="nextUnit()" :class="units.length - 1 == showIndex ? 'disabled' : ''" v-if="units.length > 1">
                <span class="small">{{ __('lang.kwl.edit_next_unit') }}</span>
                <svg class="icon icon-xs pl-1 m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.next" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </a>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="accordion" id="accordionUnitsEquipment">
                    <div v-for="(unit, index) in units" v-if="unit.rooms.length > 0">
                        <div class="row mb-2 align-items-center">
                            <div class="col-auto pr-0">
                                <button class="btn btn-block d-flex align-items-center text-left no-gutters collapsed" data-toggle="collapse" v-b-toggle="'equipment-selection-unit_' + index">
                                    <span class="col-auto pr-3">
                                        <svg class="icon m-0">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </span>
                                    <span class="col-auto">{{ unit.getSpecification(__) }}</span>
                                </button>
                            </div>
                            <!--                             <span class="col-auto pl-0">
                                <a role="button" tabindex="0" v-b-popover.hover.right="__('lang.kwl.room_overview.fl_info')">
                                    <svg class="icon m-0 mb-1 text-primary">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.warning" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </a>
                            </span> -->
                            <hr class="w-100 my-0 mx-3"/>
                        </div>
                        <b-collapse class="collapse pl-3" :visible="index == showIndex" :id="'equipment-selection-unit_' + index" accordion="accordionUnitsEquipment" @show="collapseEvent(index)">
                            <div v-if="unit.rooms.length > 0 && index == showIndex">
                                <UnitComponent :unitId="unit.id" :index="index" :key="index"></UnitComponent>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Unit from '@models/building/Unit'

import materialApi from '@services/api/material'
import log from '@services/logger/index'

export default {
    components: {
        UnitComponent: () => import('./UnitComponent'),
    },
    data () {
        return {
            roomTotalSpace: [],
            showIndex: 0,
        }
    },
    methods: {
        async nextUnit () {
            await this.$enableLoadingAnimation()
            this.$nextTick(() => {
                this.showIndex++
            })
        },
        checkMoisureProtection (unit) {
            if (unit.ventilationMeasure != 1 || unit.ventilationMeasure != 7) return true
            return unitAirvolumes.checkMoisureProtection(unit)
        },
        async collapseEvent (index) {
            await this.$enableLoadingAnimation()
            this.$nextTick(() => {
                if (this.showIndex == index) {
                    this.$disableLoadingAnimation()
                }
                this.showIndex = index
            })
        },
        async getUserArticle () {
            if (!this.user.auth) {
                return
            }
            materialApi
                .returnUserArticle()
                .then((response) => {
                    this.user.articles = response
                    this.ownArticlesUpdated++
                })
                .catch((error) => {
                    log.error('get User Article')
                    log.error(error)
                })
        },
        roomSpace () {
            var array = []

            this.units.forEach(function (unit) {
                var space = 0
                unit.rooms.forEach(function (room) {
                    if (room.space != null) {
                        space = space + parseFloat(room.space)
                    }
                })
                array.push(space)
            })
            this.roomTotalSpace = array
        },
    },
    computed: {
        units () {
            return Unit.query().with(['rooms', 'airvolume']).get()
        },

        user: {
            get () {
                return this.$store.state.session.user
            },
            set (value) {
                this.$store.commit('session/updateUser', value)
            },
        },
    },
    async created () {
        //this.getUserArticle()
        this.roomSpace()
    },
    beforeCreate () {
        //document.body.classList.add("is-loading");
    },
    mounted () {
        window.scrollTo(0, 0)
        //document.getElementsByTagName("body")[0].classList.remove("is-loading");
    },
}
</script>
